<!-- 底部按钮 -->
<template>
  <div
    class='web_bottom_btn'
    @click="handleClieck"
    :style="{backgroundColor: `${options.style.bgColor}`,color: `${options.style.color}`}"
  >{{options.data.text}}</div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => { }
    }
  },
  name: 'WebBottomBtn',
  data() {
    return {};
  },

  components: {},

  methods: {
    handleClieck() {
      if (this.options.data.url.length > 0) {
        window.location.href = this.options.data.url
      } else {
        this.$notify({
          type: "warning",
          message: '敬请期待'
        })
      }
    }
  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.web_bottom_btn {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  letter-spacing: 2px;
}
</style>